export const FALL = 'FALL'
export const SPRING = 'SPRING'
export const SUMMER = 'SUMMER'

export type SEMESTER = typeof FALL | typeof SPRING | typeof SUMMER
export type CLASS_LEVEL = 'senior' | 'junior' | 'sophomore' | 'first year' | 'grad'

export type CLASS_OF = number
export type YEAR = number
